import React from 'react';
import { motion } from 'framer-motion';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-[#98FF98] bg-opacity-20 pt-12 pb-6 relative overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#ADD8E6] to-[#98FF98]"></div>
      <div className="absolute -top-32 -left-32 w-64 h-64 rounded-full bg-[#ADD8E6] opacity-10"></div>
      <div className="absolute -bottom-32 -right-32 w-64 h-64 rounded-full bg-[#98FF98] opacity-10"></div>
      
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Home des Prés</h3>
            <p className="text-gray-600 mb-4">
              Service d'accueil temporaire d'enfants pour l'Adapei28, proposant un environnement sécurisé et bienveillant pour répondre aux besoins des familles.
            </p>
            <div className="flex space-x-4">
              {[FaFacebook, FaTwitter, FaInstagram, FaLinkedin].map((Icon, index) => (
                <motion.a
                  key={index}
                  href="#"
                  className="text-gray-600 hover:text-blue-500 transition-colors duration-300"
                  whileHover={{ y: -3, scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <Icon size={18} />
                </motion.a>
              ))}
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              {['Accueil', 'Services', 'Inscription', 'Calendrier', 'FAQ', 'À propos de nous'].map((item, index) => (
                <motion.li key={index} whileHover={{ x: 5 }}>
                  <a href="#" className="text-gray-600 hover:text-blue-500 transition-colors duration-300">
                    {item}
                  </a>
                </motion.li>
              ))}
            </ul>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-blue-500 mt-1 mr-3" />
                <span className="text-gray-600">42 Rue des Prés Verts, 28000 Chartres, France</span>
              </li>
              <li className="flex items-center">
                <FaPhoneAlt className="text-blue-500 mr-3" />
                <span className="text-gray-600">+33 2 37 00 00 00</span>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="text-blue-500 mr-3" />
                <span className="text-gray-600">contact@homedespres.fr</span>
              </li>
            </ul>
          </motion.div>
        </div>
        
        <motion.div 
          className="border-t border-gray-200 mt-10 pt-6 text-center text-gray-500 text-sm"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <p>&copy; {currentYear} Home des Prés - Adapei28. Tous droits réservés.</p>
          <div className="flex justify-center space-x-4 mt-2">
            <a href="#" className="hover:text-blue-500 transition-colors duration-300">Politique de confidentialité</a>
            <span>|</span>
            <a href="#" className="hover:text-blue-500 transition-colors duration-300">Conditions d'utilisation</a>
            <span>|</span>
            <a href="#" className="hover:text-blue-500 transition-colors duration-300">Mentions légales</a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
